import React from 'react'
import { BsFacebook, BsGithub, BsLinkedin, BsTwitter } from 'react-icons/bs';
import { AiFillMediumCircle } from 'react-icons/ai';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
      <div className="footer">
        <div className="row text-md-center">
          <ul>
            <li className='text-sm-center'><Link to="/"><BsFacebook className='fs-3' /></Link></li>
            <li className='text-sm-center'><Link to="/"><BsGithub className='fs-3' /></Link></li>
            <li className='text-sm-center'><Link to="/"><AiFillMediumCircle className='fs-3' /></Link></li>
            <li className='text-sm-center'><Link to="/"><BsLinkedin className='fs-3' /></Link></li>
            <li className='text-sm-center'><Link to="/"><BsTwitter className='fs-3' /></Link></li>
          </ul>
        </div>
        
        <div className="row">
          <ul>
            <li className='text-sm-center'><Link to="/">Project</Link></li>
            <li className='text-sm-center'><Link to="/">Article</Link></li>
            <li className='text-sm-center'><Link to="/">Contact Me</Link></li>
            <li className='text-sm-center'><Link to="/">About Me</Link></li>
          </ul>
        </div>
        
        <div className="row">
          AKDev Copyright © 2022 AKDev - All rights reserved || Designed By: Abdul Khaliq 
        </div>
      </div>
    </footer>
  )
}

export default Footer